import { SxProps, Theme } from '@mui/material';

export const getDetailsModalStyles = (isDark: boolean): Record<string, SxProps<Theme>> => ({
  paper: {
    bgcolor: isDark ? '#1a2c38' : '#ffffff',
    color: isDark ? '#fff' : '#1a2c38',
    borderRadius: '12px',
    backgroundImage: 'none',
  },
  title: {
    m: 0,
    p: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e0e6ed',
  },
  grid: {
    border: 'none',
    bgcolor: 'transparent',
    color: isDark ? '#fff' : '#1a2c38',
    '& .MuiDataGrid-columnHeaders': {
      bgcolor: isDark ? 'rgba(255, 255, 255, 0.05)' : '#f8fafc',
      color: isDark ? '#8698a6' : '#5d7182',
      borderBottom: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e0e6ed',
      '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 600,
        textTransform: 'uppercase',
        fontSize: '11px',
      },
    },
    '& .MuiDataGrid-cell': {
      borderBottom: isDark ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid #f1f5f9',
      fontSize: '13px',
      padding: '0 16px',
    },
    '& .MuiDataGrid-row:hover': {
      bgcolor: isDark ? 'rgba(255, 255, 255, 0.02)' : '#f8fafc',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
  },
  actions: {
    p: 2,
    borderTop: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e0e6ed',
  },
});
